<template lang="pug">
  main.project(v-if="project")
    header.header(:style="`background-image:url(${project.header_url})`")
      main-menu
      section.intro
    section.section
      div.container
        h2.subtitle(v-if="project.date_range" class="mobile") ({{ project.date_range[0] }} / {{ project.date_range[project.date_range.length - 1] }})
        h1.title(class="mobile") {{ project.name }}
        div.legenda(v-if="project.location")
          ul.link(v-for="location in project.location" :key="location.id" @click="viewMap(project, location.id)")
            li.label {{ location.name }}
            li View on map
            span.read-more
          ul.type(v-if="project.type")
            li.label Type
            ul
              li.value(v-for="status in project.type")
                span {{ status }}
        div.wrapper.description
          div.container
            img.prj--logo(v-if="project.logo_url" :src="project.logo_url" alt="logo")
            h2(v-if=" project.date_range") ({{ project.date_range[0] }} / {{ project.date_range[project.date_range.length - 1] }})
            h1.title {{ project.name }}
            p(v-if="project.intro" v-html="project.intro")
      div.wrapper.charts(v-if="project.charts")
        div.container
          ul.is-hidden-mobile
            li(v-for="(chart, index) in project.charts" :key="chart.id_project_immagini" @click="selectTab(chart)" :class="{ 'active': chart.is_active }")
              a
                span {{ chart.didascalia }}
          section.is-hidden-mobile
            div(v-for="chart in project.charts" :key="chart.id_project_immagini" v-show="chart.is_active")
              img.img--chart(:src="chart.nome_img" alt="chart" @click="openOverlay(chart)")
          ul.is-hidden-tablet.chartMobile
            li(v-for="(chart, index) in project.charts" :key="chart.id_project_immagini" @click="selectChart(chart)" :class="{ 'active': chart.is_active }")
              div.titolo {{ chart.didascalia }}
              div.immagine
                img.img--chart(:src="chart.nome_img" alt="chart")
      div.wrapper.deployments
        div.container
          div.deployment(v-if="project.deployments && project.deployments.length")
              h3 Deployments
              ul
                li.columns.is-mobile(v-for="item in project.deployments" :key="item.deploy.id")
                  .deployment--title.column {{ item.deploy.date }}
                    span {{ item.deploy.location }}
                  .drifter.column.icon
                    span.boa {{ item.drifters.count.active}}
                    span.separator /
                    span {{ item.drifters.count.total}}
                  .float.column.icon
                    span.boa {{ item.floats.count.active }}
                    span.separator /
                    span {{ item.floats.count.total}}
                  .glider.column.icon
                    span.boa {{ item.gliders.count.active}}
                    span.separator /
                    span {{ item.gliders.count.total}}
                  .viewmap.column
                    a(@click="viewMapDeploy(item.deploy.id)") View on Map
      div.wrapper.documents(v-if="project.scientifics.length")
        div.container
          div.columns(v-for="(doc, index) in project.scientifics" :key="doc.id_project_desc")
            div.column
            div.column
              p(v-html="doc.descrizione")
      div.wrapper.mediagallery(v-if="project.images_data")
        div.gallery.container
          h4 media
            span  gallery
          carousel(
            :perPage="1"
            :perPageCustom="[[768, 2], [1024, 3]]"
            :loop="true"
            paginationColor="#c2c2c2"
            paginationActiveColor="#5477a3"
          )
            slide(
              v-for="(image, index) in project.images_data"
              :key="index"
              :style="`background-image:url(${image.nome_img})`"
              @slideClick="openOverlay(image)"
            )
              p {{ image.didascalia }}
            slide(
              class="noimg"
              v-if="project.images_data.length < 3"
            )
            slide(
              class="noimg"
              v-if="project.images_data.length === 1"
            )
      div.wrapper.reports(v-if="project.reports")
        div.reports.container
              h3 download report
              ul.pdf(project.reports)
                li(v-for="report in project.reports")
                  a(:href="report.url" target="new") {{ report.titolo }}
      div.wrapper.people(v-if="project.people")
        div.container
          h1 people involved
          div.columns.people
            div.internal.column(v-for="item in project.people" :class="`team-${item.maos}`")
              div.picture
                img(:src="`${item.foto.replace(' ', '%20')}`" width="264" height="150" alt="foto")
              h2 {{ item.nome }} {{ item.cognome }}
              h3 {{ item.tipo }}
              h4.mail(v-if="item.email_to") {{ item.email_to }}
              h4.phone(v-if="item.tel") {{ item.tel }}
              p.more-info(v-if="item.maos === 't'")
                a(:href="item.www" target="new") more info
      div.wrapper-partners(v-if="collaborators.length")
        div.container.columns
          h1.label.column collaborators
          div.column.columns.partners
            div.wrapper-logo(v-for="partner in collaborators" :key="partner.id_sponsor")
              a.logo.column(:href="partner.link" target="_blank")
                div.image
                  img(:src="partner.logo" width="72" height="96")
                div.partner-name
                  p {{ partner.nome }}
      div.wrapper-partners(v-if="externalProjects.length")
        div.container.columns
          h1.label.column External related links
          div.column.columns.partners
            div.wrapper-logo(v-for="partner in externalProjects" :key="partner.id_sponsor")
              a.logo.column(:href="partner.link" target="_blank")
                div.image
                  img(:src="partner.logo" width="72" height="96")
                div.partner-name
                  p {{ partner.nome }}
      div.wrapper-partners(v-if="mainSponsor.length")
        div.container.columns
          h1.label.column main sponsors
          div.column.columns.partners
            div.wrapper-logo(v-for="partner in mainSponsor" :key="partner.id_sponsor")
              a.logo.column(:href="partner.link" target="_blank")
                div.image
                  img(:src="partner.logo" width="72" height="96")
                div.partner-name
                  p {{ partner.nome }}
      div.overlay(:class="{ open: overlay.open }" @click="closeOverlay")
        div.slide
          img(:src="overlay.image" alt="image instrument")
        span.close(@click="closeOverlay") ×
</template>

<script>
import moment from 'moment'
import MainMenu from '@/components/MainMenu.vue'
import { Carousel, Slide } from 'vue-carousel'
export default {
  name: 'project',
  metaInfo: {
    title: 'Project'
  },
  components: {
    'main-menu': MainMenu,
    Carousel,
    Slide
  },
  computed: {
    project () {
      return this.$store.getters.project
    },
    mainSponsor () {
      return this.$store.getters.project.sponsor
        ? this.$store.getters.project.sponsor.filter(s => s.type === 'main_sponsor')
        : false
    },
    collaborators () {
      return this.$store.getters.project.sponsor
        ? this.$store.getters.project.sponsor.filter(s => s.type === 'main_collaborator')
        : false
    },
    externalProjects () {
      return this.$store.getters.project.sponsor
        ? this.$store.getters.project.sponsor.filter(s => s.type === 'external')
        : false
    }
  },
  data () {
    return {
      msg: 'PROJECTS',
      overlay: {
        open: false,
        image: ''
      }
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_PROJECT', this.$route.params.id)
    this.$store.dispatch('LOAD_LOCATIONS_LIST')
  },
  methods: {
    viewMap (project, location) {
      this.$store.commit('SET_MAP_FILTERS', {
        location: location,
        dateFrom: project.date_start,
        dateTo: project.date_end_phy || moment().format('YYYY-MM-DD'),
        project: project.id_project
      })
      this.$router.push({ path: '/data' })
    },
    viewMapDeploy (id) {
      console.log('id', id)
      this.$store.commit('SET_MAP_FILTERS', {
        location: null,
        dateFrom: this.project.date_start,
        dateTo: this.project.date_end_phy || moment().format('YYYY-MM-DD'),
        project: this.project.id_project,
        deployment: id
      })
      this.$router.push({ path: '/data' })
    },
    selectTab (selectedTab) {
      this.project.charts.forEach(tab => {
        tab.is_active = (tab.id_project_immagini === selectedTab.id_project_immagini)
      })
    },
    selectChart (selectedTab) {
      this.project.charts.forEach(tab => {
        tab.is_active = (tab.id_project_immagini === selectedTab.id_project_immagini)
      })
    },
    openOverlay (slide) {
      this.overlay.open = true
      this.overlay.image = slide.nome_img
    },
    closeOverlay () {
      this.overlay.open = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .legenda ul {
    display: inline-block;
    margin-right: 3em;
  }

  ul.type li {
    display: inline-block;
    margin-right: 1em;
  }

  .img--chart {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/views/Project.vue